module.exports = __webpack_public_path__ + "img/potato.4150b2eb.svg";